import { render, staticRenderFns } from "./JdsTableFooterRow.vue?vue&type=template&id=9f6056c6&scoped=true&"
import script from "./JdsTableFooterRow.vue?vue&type=script&lang=ts&"
export * from "./JdsTableFooterRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6056c6",
  null
  
)

export default component.exports